import React from 'react';
import { Card, Form, Select, InputNumber, Row, Col } from 'antd';
import { FormInstance } from 'antd/es/form';

const { Option } = Select;

interface LossesProps {
  form: FormInstance;
}

const Losses: React.FC<LossesProps> = ({ form }) => {
  const timeLostOptions = [
    'Compensation',
    'Benefits',
    'Vacation',
    'Sick Leave',
    'Other'
  ];

  const lostAdvancementOptions = [
    'Higher position',
    'Promotion',
    'Salary increase',
    'Better benefits',
    'Other'
  ];

  return (
    <Card title="Losses - Select any losses you had:" style={{ marginBottom: 16 }}>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            label="Time lost:"
            name={['losses_info', 'time_lost']}
          >
            <Select placeholder="Select time lost">
              {timeLostOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Cash amount lost:"
            name={['losses_info', 'cash_amount_lost']}
          >
            <InputNumber
              style={{ width: '100%' }}
              placeholder="Enter amount"
              min={0}
              precision={2}
              prefix="$"
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Lost an advancement to:"
            name={['losses_info', 'lost_advancement_to']}
          >
            <Select placeholder="Select advancement">
              {lostAdvancementOptions.map(option => (
                <Option key={option} value={option}>{option}</Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
};

export default Losses;

